var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRagZakyatInvestment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4915 51.4104L45.4915 25.7L51.9527 25.7L51.9527 51.4104C51.9527 51.736 51.6887 51.9999 51.363 51.9999L46.0812 51.9999C45.7555 51.9999 45.4915 51.736 45.4915 51.4104Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49747 51.9997V46.9483L38.5921 3.56564L39.4092 6.46277H0.0471191V0.589505C0.0471191 0.263897 0.311077 -6.10352e-05 0.636685 -6.10352e-05H46.0949V5.05135L14.1489 48.434L13.2574 45.5369H51.9525V51.4101C51.9525 51.7357 51.6886 51.9997 51.363 51.9997H6.49747Z",
    fill: "#EBB249"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3621 6.46106L25.6518 6.46106L25.6518 -0.000190173L51.3621 -0.000187925C51.6877 -0.000187897 51.9517 0.26383 51.9517 0.589513L51.9517 5.87136C51.9517 6.19704 51.6877 6.46106 51.3621 6.46106Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0471202 32.1712L0.047118 6.46091L6.50837 6.46091L6.50837 32.1712C6.50837 32.4968 6.24435 32.7608 5.91867 32.7608L0.636821 32.7608C0.311138 32.7608 0.0471203 32.4968 0.0471202 32.1712Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.640592 45.5388L26.3509 45.5388L26.3509 52L0.640591 52C0.314982 52 0.0510243 51.736 0.0510244 51.4103L0.0510253 46.1285C0.0510253 45.8028 0.314983 45.5388 0.640592 45.5388Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRagZakyatInvestment);
export default __webpack_public_path__ + "static/media/rag-zakyat-investment.14394dcb79e6a8be878651c155f5f402.svg";
export { ForwardRef as ReactComponent };